import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  uiTab: {
    minHeight: "calc(100vh - 270px)",
    height: "100% !important",
  },
  tabWrapper: {
    padding: 24,
    height: "100%",
  },
  buttonsWrapper: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  changeButton: {
    border: "1px solid #308CDB",
    width: "123px",
    marginRight: 12,
    marginLeft: 16,
    color: "#308CDB",
    font: "700 12px/14.5px Inter",
  },
  label: {
    font: "700 16px/24px Manrope",
    color: "#465869",
    marginBottom: 32,
  },
  avatarWrapper: {
    marginBottom: 32,
  },
}));

export default styles;
